module.exports = __webpack_public_path__ + "static/media/test_specialFormatting_suppress.a38835a2.csv";